<template>
  <div>
    <router-view />
    <Box title="Ayusa" link="ayusa" :image="require('@/assets/images/ayusa.png')" />
    <Box title="AupairCare" link="aupaircare" :image="require('@/assets/images/aupaircare.png')" />
    <Box title="Global Internships" link="global_internships" :image="require('@/assets/images/global_internships.png')" />
    <Box title="Aptozen" link="aptozen" :image="require('@/assets/images/aptozen2.png')" />
  </div>
</template>

<script>
import Box from '@/components/Box'

export default {
  name: 'Home',
  components: {
    Box
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue